import { render, staticRenderFns } from "./GaugeSelection.vue?vue&type=template&id=65d7e2b8&scoped=true"
import script from "./GaugeSelection.vue?vue&type=script&lang=js"
export * from "./GaugeSelection.vue?vue&type=script&lang=js"
import style0 from "./GaugeSelection.vue?vue&type=style&index=0&id=65d7e2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7e2b8",
  null
  
)

export default component.exports